<div class="eiq-input-radio-group__container" [ngClass]="[appearance()]">
  @if (label()) {
    <span class="fs__sm fw__500 label">
      {{ label() }}
      @if (tooltip()) {
        <fa-icon [icon]="faInfoCircle" class="caption" [matTooltip]="tooltip()"></fa-icon>
      }
    </span>
  }

  <mat-radio-group class="eiq-input-radio-group" aria-label="Select an option" [attr.data-testid]="testId$() + '-radio'" (change)="mapToControl($event)">
    <mat-radio-button
      *ngFor="let option of options(); let i = index"
      class="eiq-input-radio-group__field"
      [checked]="option.value === selectedValue"
      [color]="palette()"
      [attr.data-testid]="testId$() + '-option-' + i + '-radio'"
      [value]="option.value"
    >
      <div class="radio-label-container">
        <span class="main-text label">{{ option.text }}</span>
      </div>
    </mat-radio-button>
  </mat-radio-group>
</div>
